import { Notification } from '@cambridgeassessment/cambridge-ui';
import { Box, Typography } from '@material-ui/core';
import React, { memo } from 'react';
import MakePrimary from './MakePrimary';
import Remove from './Remove';
import { useStylesRow as useStyles } from './styles';
import { EmailType } from './types';

type Props = {
  className?: string;
  email: string;
  type: EmailType;
  verify?: () => void;
  remove?: () => void;
  makePrimary?: () => void;
};

const EmailRow: React.FC<Props> = ({
  className,
  email,
  type,
  verify,
  remove,
  makePrimary,
}) => {
  const classes = useStyles(type);

  switch (type) {
    case EmailType.Primary:
      return (
        <Box className={className}>
          <Typography
            variant="body1"
            className={`${classes.email} ${classes.primaryEmail}`}
            data-testid="emailRow-primary"
          >
            {`${email} (Primary)`}
          </Typography>
        </Box>
      );

    case EmailType.Unverified:
      return (
        <>
          <Box className={classes.container}>
            <Typography className={classes.emailContainer}>
              <span className={classes.email} data-testid="emailRow-unverified">
                {`${email} `}
              </span>
              <span className={classes.label}>(not verified)</span>
            </Typography>
            <div className={classes.actions}>
              <Remove onClick={remove} />
            </div>
          </Box>
          <Notification
            data-testid="verify-notification"
            size="small"
            action={{
              onClick: verify,
              text: 'Resend verification',
            }}
            title="Verification needed."
            variant="warning"
            className={classes.notification}
          >
            Check your inbox for verification link.
          </Notification>
        </>
      );

    case EmailType.Verified:
      return (
        <Box className={classes.container}>
          <Typography
            variant="body1"
            className={classes.email}
            data-testid="emailRow-verified"
          >
            {email}
          </Typography>
          <Box className={classes.actions}>
            <MakePrimary
              onClick={makePrimary}
              className={classes.makePrimary}
            />
            <Remove onClick={remove} />
          </Box>
        </Box>
      );

    default:
      return null;
  }
};

export default memo(EmailRow);
